/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import Vue from 'vue';

var RenderComponent = Vue.extend({
  name: "render-component",
  functional: true,
  props: {
    render: Function
  },
  render: function render(h, ctx) {
    return ctx.props.render(h, ctx.data.attrs);
  }
});

export { RenderComponent as default };
//# sourceMappingURL=render-component.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/utils/render-component.js
// module id = null
// module chunks = 